import React from 'react'
import classNames from 'classnames'

import style from './TmoInputDate.module.css'

function TmoInputDate({ value = '', onChange, disabled, className, testId, ...rest }) {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <input
      className={classNames(style.input, className)}
      type='date'
      onChange={handleChange}
      data-testid={testId}
      {...rest}
    />
  )
}

export default TmoInputDate
